import {BaseContainerModel} from '../../base-container.model';
import {bl_fi_generic_doc_approval_sequence_RowClass} from '../../../dbschema';

export class GenericDocApprovalSequenceContainerModel extends BaseContainerModel {
  bl_fi_generic_doc_approval_sequence: bl_fi_generic_doc_approval_sequence_RowClass = new bl_fi_generic_doc_approval_sequence_RowClass();
}
